module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-13.b3d5cbe9.png";